import { isServer } from 'src/shared/helpers/environment';

const isDesignStudioInIframe = (): boolean => {
  if (!isServer()) {
    try {
      return window.self !== window.top;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export { isDesignStudioInIframe };
